import React, { useState } from "react";
import { Box, Container, Heading, Text, VStack, HStack, Icon, FormControl, FormLabel, Input, Select, Button, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { FaChartArea } from "react-icons/fa";
import { NavbarWithCallToAction } from "../../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { SEOHead } from "../../../components/SEOHead";

const PROPERTY_PRIMARY = "#0D7F6E";
const NAVY = "#141C49";

const PropertyToolsPortfolioGrowth: React.FC = () => {
  const [initial, setInitial] = useState(600000);
  const [growth, setGrowth] = useState(7);
  const [years, setYears] = useState(10);

  const future = initial * Math.pow(1 + growth/100, years);
  const totalGrowth = future - initial;

  return (
    <Box minH="100vh" bg="white">
      <SEOHead pagePath="/property/tools/portfolio-growth" fallbackTitle="Portfolio Growth Projector" fallbackDescription="Project long-term portfolio growth" />
      <NavbarWithCallToAction />
      <Box bgGradient={`linear(to-r, ${NAVY}, ${PROPERTY_PRIMARY})`} color="white" py={20}>
        <Container maxW="container.xl"><VStack spacing={6} textAlign="center"><Icon as={FaChartArea} boxSize={16} /><Heading size="3xl" fontWeight="black">Portfolio Growth Projector</Heading><Text fontSize="xl">Project your portfolio value over time</Text></VStack></Container>
      </Box>
      <Container maxW="container.xl" py={16}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12}>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Projection Settings</Heading>
            <FormControl><FormLabel>Initial Portfolio Value</FormLabel><Input type="number" value={initial} onChange={(e) => setInitial(Number(e.target.value))} /></FormControl>
            <FormControl><FormLabel>Annual Growth Rate (%)</FormLabel><Input type="number" value={growth} onChange={(e) => setGrowth(Number(e.target.value))} step="0.1" /></FormControl>
            <FormControl><FormLabel>Time Horizon (Years)</FormLabel><Select value={years} onChange={(e) => setYears(Number(e.target.value))}><option value={5}>5 Years</option><option value={10}>10 Years</option><option value={15}>15 Years</option><option value={20}>20 Years</option></Select></FormControl>
            <Button bg={PROPERTY_PRIMARY} color="white" _hover={{ bg: "#0a6459" }} size="lg" transition="all 0.2s">Project Growth</Button>
          </VStack>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Projections</Heading>
            <Stat bg="#EEF0F7" p={6} borderRadius="lg"><StatLabel>Future Value ({years} years)</StatLabel><StatNumber fontSize="3xl" color={NAVY}>${future.toLocaleString('en-US', {maximumFractionDigits: 0})}</StatNumber></Stat>
            <Stat bg="#E1F0EC" p={6} borderRadius="lg"><StatLabel>Total Growth</StatLabel><StatNumber fontSize="3xl" color={PROPERTY_PRIMARY}>${totalGrowth.toLocaleString('en-US', {maximumFractionDigits: 0})}</StatNumber></Stat>
            <Box bg="gray.50" p={6} borderRadius="lg">
              <Heading size="sm" mb={4} color={NAVY}>Milestone Projections</Heading>
              <VStack align="stretch" spacing={3}>
                {[5, 10, 15, 20].filter(y => y <= years).map(y => {
                  const value = initial * Math.pow(1 + growth/100, y);
                  return <HStack key={y} justify="space-between"><Text fontSize="sm">Year {y}</Text><Text fontWeight="bold">${value.toLocaleString('en-US', {maximumFractionDigits: 0})}</Text></HStack>
                })}
              </VStack>
            </Box>
          </VStack>
        </SimpleGrid>
      </Container>
      <FooterWithFourColumns />
    </Box>
  );
};

export default PropertyToolsPortfolioGrowth;
